module.exports = __webpack_public_path__ + "static/media/total-invoices-blue.ad75ae48.svg";